module.exports = __webpack_public_path__ + "img/highlight-2-m.ee44ed11.png";